import React from "react";
import { Link } from "react-router-dom";

const InnerHeaderBanner = (props) => {
  const breadcrumbsStyle = {
    fontSize: window.innerWidth <= 500 ? "1.7rem" : "",
  };
  return (
    <>
      <div
        className="breadcrumbs d-flex align-items-center"
        style={{
          backgroundImage: `url(${props.img})`,
          backgroundPosition: "fit-content",
          backgroundPositionY:"35%"
        }}
      >
        <div className="container position-relative d-flex flex-column align-items-center">
          <h2 style={breadcrumbsStyle}>{props.name}</h2>
          <ol>
            <li>
              <Link to="/">
                <i class="bi bi-house-door"></i> Home
              </Link>
            </li>
            <li>{props.name}</li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default InnerHeaderBanner;
